import React from "react";
import { useNavigate } from "react-router-dom";
import SidebarAdmin from "../../menu/SidebarAdmin";
import Topbar from "../../menu/Topbar";
import CardsAdminUsuarios from "../../cards/CardsAdminUsuarios";
import BtnAcessoRapido from "../../AcessoRapido/BtnAcessoRapido";
import ListaUsuarios from "../ListaUsuarios/ListaUsuarios";
import Api from "../../Services/Api";

const Usuarios = () => {
  const navigate = useNavigate();

  const [menuClose, setMenuClose] = React.useState(false);
  const [usuarios, setUsuarios] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  const toggleMenu = () => setMenuClose((prev) => !prev);

  React.useEffect(() => {
    const fetchUsuarios = async () => {
      try {
        setLoading(true);
        const res = await Api.get("/usuarios");
        setUsuarios(res.data);
      } catch (err) {
        console.error("Erro ao buscar usuarios:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUsuarios();
  }, []);

  const handleEdit = (userId) => {
    navigate(`/adicionarusuarios/${userId}`);
  };

  const handleToggleStatus = async (item) => {
    const statusAtual = String(item?.status || "").toUpperCase();
    const novoStatus = statusAtual === "INACTIVE" ? "ACTIVE" : "INACTIVE";

    try {
      await Api.patch(`/usuarios/${item.id}/status`, { status: novoStatus });

      setUsuarios((prev) =>
        prev.map((u) =>
          Number(u.id) === Number(item.id)
            ? {
                ...u,
                status: novoStatus,
              }
            : u
        )
      );
    } catch (err) {
      const message =
        err?.response?.data?.message || "Nao foi possivel atualizar o status do usuario.";
      throw new Error(message);
    }
  };

  const usuariosLicenciados = usuarios.filter(
    (u) => u.access_type?.toUpperCase() === "LICENSED"
  );

  const usuariosAtivos = usuariosLicenciados.filter(
    (u) => u.status?.toLowerCase() === "active"
  ).length;

  const usuariosInativos = usuariosLicenciados.filter(
    (u) => u.status?.toLowerCase() === "inactive"
  ).length;

  return (
    <div className="app-container">
      <SidebarAdmin close={menuClose} usuariosActive="active" />

      <main className="main-content">
        <Topbar page="Lista de Usuarios / Licenciados" onToggleMenu={toggleMenu} />

        <CardsAdminUsuarios
          total={usuariosLicenciados.length}
          ativos={usuariosAtivos}
          inativos={usuariosInativos}
        />

        <BtnAcessoRapido
          icone="+"
          text="Adicionar usuario / licenciado"
          link="/adicionarusuarios"
        />

        {loading ? (
          <p>Carregando usuarios...</p>
        ) : (
          <ListaUsuarios
            lista={usuarios}
            onEdit={handleEdit}
            onToggleStatus={handleToggleStatus}
          />
        )}
      </main>
    </div>
  );
};

export default Usuarios;
